import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-16.jpg'
import _imports_1 from '@/assets/images/user-17.jpg'
import _imports_2 from '@/assets/images/user-18.jpg'
import _imports_3 from '@/assets/images/user-19.jpg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "timeline-wrap" }
const _hoisted_4 = { class: "timeline-item-2 mb-5" }
const _hoisted_5 = { class: "text p-4 rounded-3" }
const _hoisted_6 = { class: "ps-0 mb-3 list-unstyled d-flex align-items-center" }
const _hoisted_7 = { class: "ms-m-15" }
const _hoisted_8 = { class: "ms-m-15" }
const _hoisted_9 = { class: "ms-m-15" }
const _hoisted_10 = { class: "ms-m-15" }
const _hoisted_11 = { class: "timeline-item-2 mb-5" }
const _hoisted_12 = { class: "text p-4 rounded-3" }
const _hoisted_13 = { class: "ps-0 mb-3 list-unstyled d-flex align-items-center" }
const _hoisted_14 = { class: "ms-m-15" }
const _hoisted_15 = { class: "ms-m-15" }
const _hoisted_16 = { class: "ms-m-15" }
const _hoisted_17 = { class: "ms-m-15" }
const _hoisted_18 = { class: "timeline-item-2" }
const _hoisted_19 = { class: "text p-4 rounded-3" }
const _hoisted_20 = { class: "ps-0 mb-3 list-unstyled d-flex align-items-center" }
const _hoisted_21 = { class: "ms-m-15" }
const _hoisted_22 = { class: "ms-m-15" }
const _hoisted_23 = { class: "ms-m-15" }
const _hoisted_24 = { class: "ms-m-15" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "mb-4" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Advanced Timeline")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "fs-14 fw-medium text-primary" }, " Weekly Stand-Up Meetings: ", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("p", null, " We continued our weekly stand-up meetings where team members provided updates on their current tasks, discussed any roadblocks, and coordinated efforts for the week ahead. ", -1)),
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                      alt: "user"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                      alt: "user"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_8, [
                _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                      alt: "user"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createElementVNode("img", {
                      src: _imports_3,
                      class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                      alt: "user"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_10, [
                _createVNode(_component_RouterLink, {
                  to: "/users/users-list",
                  class: "wh-34 lh-34 rounded-circle bg-primary d-block text-center text-decoration-none text-white fs-12 fw-medium border border-1 border-color-white"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" +10 ")
                  ])),
                  _: 1
                })
              ])
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "d-block text-primary" }, [
              _createElementVNode("span", { class: "text-body fw-medium" }, "By:"),
              _createTextVNode(" Olivia Rodriguez")
            ], -1))
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "icon" }, [
            _createElementVNode("div")
          ], -1)),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "time" }, [
            _createElementVNode("time", null, "12:00 AM, 25 Mar, 2024")
          ], -1))
        ]),
        _cache[30] || (_cache[30] = _createStaticVNode("<div class=\"timeline-item-2 mb-5\"><div class=\"text p-4 rounded-3\"><h3 class=\"fs-14 fw-medium text-primary\"> Project Kickoff Session: </h3><p> Briefly explain the purpose of the kickoff session and its importance in setting the project on the right track. Discuss any assumptions made about the scope and clarify </p><span class=\"d-block text-primary\"><span class=\"text-body fw-medium\">By:</span> Olivia Rodriguez</span></div><div class=\"icon two\"><div></div></div><div class=\"time\"><time>04:00 PM, 24 Mar, 2024</time></div></div>", 1)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "fs-14 fw-medium text-primary" }, " Team Building Workshop: ", -1)),
            _cache[16] || (_cache[16] = _createElementVNode("p", null, " Arrange for a suitable venue and ensure that any necessary materials or resources are readily available. Start the workshop with a fun icebreaker activity to help team members ", -1)),
            _createElementVNode("ul", _hoisted_13, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                      alt: "user"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_14, [
                _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                      alt: "user"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_15, [
                _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                      alt: "user"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_16, [
                _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createElementVNode("img", {
                      src: _imports_3,
                      class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                      alt: "user"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_17, [
                _createVNode(_component_RouterLink, {
                  to: "/users/users-list",
                  class: "wh-34 lh-34 rounded-circle bg-primary d-block text-center text-decoration-none text-white fs-12 fw-medium border border-1 border-color-white"
                }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createTextVNode("+10")
                  ])),
                  _: 1
                })
              ])
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "d-block text-primary" }, [
              _createElementVNode("span", { class: "text-body fw-medium" }, "By:"),
              _createTextVNode(" Olivia Rodriguez")
            ], -1))
          ]),
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "icon three" }, [
            _createElementVNode("div")
          ], -1)),
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "time" }, [
            _createElementVNode("time", null, "02 PM, 23 Mar, 2024")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "fs-14 fw-medium text-primary" }, " Lunch & Learning Session: ", -1)),
            _cache[26] || (_cache[26] = _createElementVNode("p", null, " Determine a convenient time and date for the session, ideally during a lunch break or over a lunch hour. Start the session on time and welcome all participants. ", -1)),
            _createElementVNode("ul", _hoisted_20, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                      alt: "user"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_21, [
                _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                      alt: "user"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_22, [
                _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                      alt: "user"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_23, [
                _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createElementVNode("img", {
                      src: _imports_3,
                      class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                      alt: "user"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_24, [
                _createVNode(_component_RouterLink, {
                  to: "/users/users-list",
                  class: "wh-34 lh-34 rounded-circle bg-primary d-block text-center text-decoration-none text-white fs-12 fw-medium border border-1 border-color-white"
                }, {
                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                    _createTextVNode(" +10 ")
                  ])),
                  _: 1
                })
              ])
            ]),
            _cache[27] || (_cache[27] = _createElementVNode("span", { class: "d-block text-primary" }, [
              _createElementVNode("span", { class: "text-body fw-medium" }, "By:"),
              _createTextVNode(" Olivia Rodriguez")
            ], -1))
          ]),
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "icon four" }, [
            _createElementVNode("div")
          ], -1)),
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "time" }, [
            _createElementVNode("time", null, "12:00 PM, 22 Mar, 2024")
          ], -1))
        ])
      ])
    ])
  ]))
}